module.exports = __webpack_public_path__ + "img/contacts_region.62011407.svg";